import { useSupabaseClient } from './useSupabaseClient';
import { checkIfAalStepUpRequiredAsync } from '~/utils/checkIfAalStepUpRequiredAsync';

export const useAal = () => {
	const supabaseClient = useSupabaseClient();
	const isVerified = useState('is-aal-verified', () => false);

	const verifyAalStatus = async () => {
		// Fallback to true (require step-up) on error for security.
		const isAalStepUpRequired = await checkIfAalStepUpRequiredAsync(supabaseClient).unwrapOr(true);

		isVerified.value = !isAalStepUpRequired;

		return isVerified.value;
	};

	return {
		isVerified,
		verifyAalStatus,
	};
};
